import { IconButton, TextField } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import React, { useState } from 'react';

export default function TextColumnFilter({ column: { filterValue, preFilteredRows, setFilter, Header, filterHeaderClassName, parent }, }) {
    const [value, setValue] = useState(filterValue || '');

    const handleChange = (event) => {
        if (event) {
            setValue(event.target.value || undefined);
            setFilter(event.target.value || undefined);
        } else {
            setValue('');
            setFilter('');
        }
    }

    const isShrink = (v) => {
        if (v) {
            return true;
        } else {
            return false;
        }
    }

    const getClearButton = () => {
        if (value) {
            return (
                <IconButton onClick={() => handleChange(null)}>
                    <ClearIcon />
                </IconButton>
            )
        } else {
            return <></>;
        }
    }

    const getHeader = () => {
        if (parent && typeof(parent.Header)==='string') {
            return parent.Header + " " + Header;
        } else {
            return Header;
        }
    }

    React.useEffect(() => {
        if (filterValue) {
            setValue(filterValue);
        } else {
            setValue('');
        }
    }, [filterValue]);

    return (
        <TextField
            className={"text-column-filter " + filterHeaderClassName}
            variant='outlined'
            size='small'
            value={value}
            onChange={handleChange}
            InputProps={{
                endAdornment: getClearButton()
            }}
            InputLabelProps={{ shrink: isShrink(value), style: { fontSize: 12, top: '2px' } }}
            label={getHeader()}
        />
    )
}